/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractorDeliverablesList_stateTypes$ref: FragmentReference;
declare export opaque type ContractorDeliverablesList_stateTypes$fragmentType: ContractorDeliverablesList_stateTypes$ref;
export type ContractorDeliverablesList_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ContractorDeliverablesList_stateTypes$ref,
|};
export type ContractorDeliverablesList_stateTypes$data = ContractorDeliverablesList_stateTypes;
export type ContractorDeliverablesList_stateTypes$key = {
  +$data?: ContractorDeliverablesList_stateTypes$data,
  +$fragmentRefs: ContractorDeliverablesList_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContractorDeliverablesList_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fdcc6428d9139c94b8a4b23d63ce4cf4';
module.exports = node;
